<template>
  <v-list>
    <ScopeSelector v-if="show()" />
  </v-list>
</template>

<script>
import constants from '@/config/constants';
import ScopeSelector from '@/components/common/navigation/ScopeSelector';

export default {
  name: 'NavigationError',
  components: {
    ScopeSelector
  },
  props: {
    errorCode: {
      type: String,
      required: false
    }
  },
  methods: {
    show() {
      return this.errorCode === constants.errors.CHANGE_SCOPE;
    }
  }
};
</script>

<style scoped></style>
